var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor",class:{hover: _vm.hovered },style:({left: (_vm.x + "px"), top: (_vm.y + "px")})},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }